import moment from "moment";

export const canRenewOn = (endDate: string) => {
  return new Date(
    moment(endDate)
      .add(-1, "month")
      .toString()
  );
};
